import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import { useDispatch } from "react-redux";
import { Bounce, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contactUsSubmit } from "../../../redux/features/contactUs/contactUsService";
import { FaFacebookSquare, FaLinkedin } from "react-icons/fa";
import { BeatLoader } from "react-spinners";

const ContactUs = () => {
  const [data, setData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [error, setErrors] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [disabledBtn, setDisabledBtn] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
    setErrors({ ...error, [e.target.name]: "" });
  };

  const validatePayment = () => {
    const errors = {
      name: "",
      email: "",
      phoneNumber: "",
      message: "",
    };

    if (!data.name) errors.name = "Name is required.";

    if (!data.email) {
      errors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(data.email)) {
      errors.email = "Invalid email format.";
    }

    if (!data.phoneNumber) errors.phoneNumber = "Phone Number is required.";

    if (!data.message) errors.message = "Message is required.";

    setErrors(errors);
    return !Object.values(errors).some((err) => err);
  };

  const showToast = ({ success, message }) => {
    const options = {
      position: "bottom-right",
      autoClose: 5000,
      theme: "light",
      transition: Bounce,
    };

    if (success) {
      toast.success(message, options);
    } else {
      toast.error(message, options);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validatePayment()) {
      setDisabledBtn(true);

      try {
        const response = await dispatch(
          contactUsSubmit({
            name: data.name,
            email: data.email,
            phone_number: data.phoneNumber,
            message: data.message,
          })
        ).unwrap();

        if (response.success) {
          showToast({ success: true, message: response.message });

          setData({
            name: "",
            email: "",
            phoneNumber: "",
            message: "",
          });
        } else {
          showToast({ success: false, message: response.message });
        }
      } catch (error) {
        showToast({ success: false, message: error.message });
      } finally {
        setDisabledBtn(false);
      }
    }
  };

  return (
    <div className="main-container">
      <div className="container-content wrapped-content">
        <ToastContainer />
        <div className={styles.contactCard}>
          <div className={styles.contactLeft}>
            <p className={styles.contactTitle}>
              Send Your <br /> Message to Us
            </p>
            <div className={styles.socialMedia}>
              <div className={styles.followText}>Follow us on social media</div>
              <div className={styles.socialIcons}>
                <FaFacebookSquare className={styles.smIcon} />
                <FaLinkedin className={styles.smIcon} />
              </div>
            </div>
            <div className={styles.contactAddress}>
              <h5 className={styles.touchTitle}>Get in Touch</h5>

              <div className={styles.addSection}>
                <div className={styles.addWrapper}>
                  <p className={styles.addTitle}>Address</p>
                  <p>Meegalla Holdings (Pvt) Ltd</p>
                  <p>10, Wijerama Road, Colombo 07</p>
                </div>
              </div>

              <div className={styles.addSection}>
                <div className={styles.addWrapper}>
                  <p className={styles.addTitle}>Phone</p>
                  <p>+94 77 775 7479</p>
                </div>
              </div>

              <div className={styles.addSection}>
                <div className={styles.addWrapper}>
                  <p className={styles.addTitle}>Email</p>
                  <p>sales@mholdings.lk</p>
                </div>
              </div>
            </div>
            <div className={styles.powered}>
              <p>
                MHoldings: Design & Developed by{" "}
                <a
                  href="https://www.ardillalabs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#c93b25", textDecoration: "none" }}
                >
                  www.ardillalabs.com
                </a>
              </p>
            </div>
          </div>
          <div className={styles.formWrapper}>
            <h4 className={styles.message}>
              Fill the form and send your message. <br /> We will contact you soon!
            </h4>
            <form className={styles.form} onSubmit={handleSubmit}>
              <div className={`form-input-group`}>
                <label className={`form-label`}>Name</label>
                <input
                  type="text"
                  name="name"
                  value={data.name}
                  onChange={handleChange}
                  className={`form-input-default`}
                />
                {error.name && (
                  <span className={`error-msg`}>{error.name}</span>
                )}
              </div>
              <div className={`form-input-group`}>
                <label className={`form-label`}>Email</label>
                <input
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                  className={`form-input-default`}
                />
                {error.email && (
                  <span className={`error-msg`}>{error.email}</span>
                )}
              </div>
              <div className={`form-input-group`}>
                <label className={`form-label`}>Phone Number</label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={data.phoneNumber}
                  onChange={handleChange}
                  className={`form-input-default`}
                />
                {error.phoneNumber && (
                  <span className={`error-msg`}>{error.phoneNumber}</span>
                )}
              </div>

              <div className={`form-input-group`}>
                <label className={`form-label`}>Message</label>
                <textarea
                  rows={5}
                  name="message"
                  value={data.message}
                  onChange={handleChange}
                  className={`form-input-default`}
                />
                {error.message && (
                  <span className={`error-msg`}>{error.message}</span>
                )}
              </div>

              <button
                className={styles.submitBtn}
                type="submit"
                disabled={disabledBtn}
              >
                {disabledBtn ? <BeatLoader /> : `Send your message`}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;